import script from "./DashboardComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardComponent.vue?vue&type=script&setup=true&lang=js"

import "./DashboardComponent.vue?vue&type=style&index=0&id=0558aa72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0558aa72"]])

export default __exports__